import React, { useState, useEffect, useRef } from 'react';
import DateRangeFilter from '../dateRangeFilter';
import Select from 'react-select';
import { 
  getSolpedNumberList,
  getAtcNumberList,
  getOtNumberList,
  getCentersList,
  getOcNumberList,
  getStatusGeneralList
} from '../../../client/atc';

const ATCFilters = ({
  onDateRangeChange = () => {},
  onFilterChange = () => {},
  applyFilters,
  activeFilters = {},
  resetFlag,
  position = "md:right-0 right-auto",
  supplierId,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const [solpedOptions, setSolpedOptions] = useState([]);
  const [selectedSolpeds, setSelectedSolpeds] = useState([]);
  const [loadingSolpeds, setLoadingSolpeds] = useState(false);

  const [numberAtcOptions, setNumberAtcOptions] = useState([]);
  const [selectedNumberAtc, setSelectedNumberAtc] = useState([]);
  const [loadingNumberAtc, setLoadingNumberAtc] = useState(false);


  const [numeroOTOptions, setNumeroOTOptions] = useState([]);
  const [selectedNumeroOT, setSelectedNumeroOT] = useState([]);
  const [loadingNumeroOT, setLoadingNumeroOT] = useState(false);

  const [numeroOCOptions, setNumeroOCOptions] = useState([]);
  const [selectedNumeroOC, setSelectedNumeroOC] = useState([]);
  const [loadingNumeroOC, setLoadingNumeroOC] = useState(false);


  const [centersOptions, setCentersOptions] = useState([]);
  const [selectedCenters, setSelectedCenters] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);

  const [estadoGeneralOptions, setEstadoGeneralOptions] = useState([]);
  const [selectedEstadoGeneral, setSelectedEstadoGeneral] = useState([]);
  const [loadingEstadoGeneral, setLoadingEstadoGeneral] = useState(false);

  const filtersRef = useRef(null);

  const [selectedDateRange, setSelectedDateRange] = useState({ 
    startDate: '', 
    endDate: '' 
  });
  
  useEffect(() => {
    const loadSolpedOptions = async () => {
      if (showFilters && solpedOptions.length === 0) {
        try {
          setLoadingSolpeds(true);
          const response = await getSolpedNumberList();
          
          if (response && response.solpedNumbersList) {
            const options = response.solpedNumbersList.map(numero => ({
              value: numero,
              label: numero
            }));
            setSolpedOptions(options);
          }
        } catch (error) {
          console.error('Error cargando números solped:', error);
          setSolpedOptions([]);
        } finally {
          setLoadingSolpeds(false);
        }
      }
    };

  const loadAtcNumbers = async () => {
    try {
      setLoadingNumberAtc(true);
      const response = await getAtcNumberList(); 
      
      const options = response.atcNumbers.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumberAtcOptions(options);
    } catch (error) {
      console.error('Error cargando números ATC:', error);
      setNumberAtcOptions([]);
    } finally {
      setLoadingNumberAtc(false);
    }
  };

  //Listar números OT
  const loadOtNumbers = async () => {
    try {
      setLoadingNumeroOT(true);
      const response = await getOtNumberList();
      
      const options = response.otNumbers.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumeroOTOptions(options);
    } catch (error) {
      console.error('Error cargando números OT:', error);
      setNumeroOTOptions([]);
    } finally {
      setLoadingNumeroOT(false);
    }
  };

//Lista embarcacion(centros)
  const loadCentersList = async () => {
    try {
      setLoadingCenters(true);
      const response = await getCentersList(); 
      
      const options = response.centersList.map(center => ({
        value: center,
        label: center
      }));
      
      setCentersOptions(options);
    } catch (error) {
      console.error('Error cargando embarcaciones:', error);
      setCentersOptions([]);
    } finally {
      setLoadingCenters(false);
    }
  };

    const loadOCNumbers = async () => {
      try {
        setLoadingNumeroOC(true);
      const response = await getOcNumberList(supplierId ? [supplierId] : undefined); 
        
        if (response && response.ocNumbers) {
          const options = response.ocNumbers.map(numero => ({
            value: numero,
            label: numero
          }));
          setNumeroOCOptions(options);
        }
      } catch (error) {
        console.error('Error cargando números OC:', error);
        setNumeroOCOptions([]);
      } finally {
        setLoadingNumeroOC(false);
      }
    };

    const loadStatusGeneral = async () => {
      try {
        setLoadingEstadoGeneral(true);
        const response = await getStatusGeneralList();
        
        const options = response.statuses.map(status => ({
          value: status.id.toString(),
          label: status.description
        }));
        
        setEstadoGeneralOptions(options);
      } catch (error) {
        console.error('Error cargando estados generales:', error);
        setEstadoGeneralOptions([]);
      } finally {
        setLoadingEstadoGeneral(false);
      }
    };



    loadAtcNumbers();
    loadSolpedOptions();
    loadOtNumbers();
    loadCentersList();
    loadOCNumbers();
    loadStatusGeneral();
  }, [showFilters]);



const handleSolpedChange = (selectedOptions) => {
  setSelectedSolpeds(selectedOptions);
  onFilterChange(
    "Número Solped:", 
    selectedOptions.map(option => option.value)
  )
};

  const handleNumberAtcChange = (selectedOptions) => {
    setSelectedNumberAtc(selectedOptions);
    onFilterChange(
      "Número de ATC:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroOTChange = (selectedOptions) => {
    setSelectedNumeroOT(selectedOptions);
    onFilterChange(
      "Número de OT:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleCentersChange = (selectedOptions) => {
    setSelectedCenters(selectedOptions);
    onFilterChange(
      "Embarcación:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroOCChange = (selectedOptions) => {
    setSelectedNumeroOC(selectedOptions);
    onFilterChange(
      "Número de OC:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleEstadoGeneralChange = (selectedOptions) => {
    setSelectedEstadoGeneral(selectedOptions);
    onFilterChange(
      "Estado general del servicio:",
      selectedOptions.map(option => parseInt(option.value))
    );
  };
    
  useEffect(() => {
    if (resetFlag) {
      setSelectedSolpeds([]);
      setSelectedNumberAtc([]);
      setSelectedNumeroOT([]);
      setSelectedCenters([]);
      setSelectedNumeroOC([]);
      setSelectedEstadoGeneral([]);
      setSelectedDateRange({ startDate: '', endDate: '' });
    }
  }, [resetFlag]);

  useEffect(() => {
    if (activeFilters.emissionDateFrom && activeFilters.emissionDateTo) {
      setSelectedDateRange({
        startDate: activeFilters.emissionDateFrom,
        endDate: activeFilters.emissionDateTo
      });
    } else {
      setSelectedDateRange({ startDate: '', endDate: '' });  
    }
    
    if (activeFilters.solpedNumbers && activeFilters.solpedNumbers.length > 0) {
      const selectedOptions = activeFilters.solpedNumbers.map(num => ({
        value: num,
        label: num
      }));
      setSelectedSolpeds(selectedOptions);
    } else {
      setSelectedSolpeds([]);
    }

    if (activeFilters.atcNumbers && activeFilters.atcNumbers.length > 0) {
      const selectedOptions = activeFilters.atcNumbers.map(num => ({
        value: num,
        label: num
      }));
      setSelectedNumberAtc(selectedOptions);
    } else {
      setSelectedNumberAtc([]);
    }

    if (activeFilters.otNumbers && activeFilters.otNumbers.length > 0) {
      const selectedOptions = activeFilters.otNumbers.map(num => ({
        value: num,
        label: num
      }));
      setSelectedNumeroOT(selectedOptions);
    } else {
      setSelectedNumeroOT([]);
    }

    if (activeFilters.centersList && activeFilters.centersList.length > 0) {
      const selectedOptions = activeFilters.centersList.map(center => ({
        value: center,
        label: center
      }));
      setSelectedCenters(selectedOptions);
    } else {
      setSelectedCenters([]);
    }

    if (activeFilters.ocNumbers && activeFilters.ocNumbers.length > 0) {
      const selectedOptions = activeFilters.ocNumbers.map(num => ({
        value: num,
        label: num
      }));
      setSelectedNumeroOC(selectedOptions);
    } else {
      setSelectedNumeroOC([]);
    }

    if (activeFilters.statusGeneralIds && activeFilters.statusGeneralIds.length > 0) {

      const selectedOptions = activeFilters.statusGeneralIds.map(id => {
        const option = estadoGeneralOptions.find(opt => parseInt(opt.value) === id);
        return option || { value: id.toString(), label: `Estado ${id}` };
      });
      setSelectedEstadoGeneral(selectedOptions);
    } else {
      setSelectedEstadoGeneral([]);
    }

  }, [activeFilters]);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filtersRef.current && !filtersRef.current.contains(event.target)) {
        setShowFilters(false);
      }
    };

    if (showFilters) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters]);

  const toggleFilters = () => setShowFilters(!showFilters);


  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSelectedDateRange({ startDate, endDate });
    onDateRangeChange({ startDate, endDate });
  };

  const handleApplyFilters = () => {
    applyFilters();
    setShowFilters(false);
  };

const hasActiveFilters = () => {
  const hasDateFilters = 
    activeFilters.emissionDateFrom && 
    activeFilters.emissionDateTo && 
    activeFilters.emissionDateFrom !== '' && 
    activeFilters.emissionDateTo !== '';
  
  const hasSolpedFilters = 
    activeFilters.solpedNumbers && activeFilters.solpedNumbers.length > 0;
  
  const hasAtcFilters = 
    activeFilters.atcNumbers && activeFilters.atcNumbers.length > 0; 

  const hasOtFilters = 
    activeFilters.otNumbers && activeFilters.otNumbers.length > 0; 
  
  const hasCenterFilters = 
    activeFilters.centersList && activeFilters.centersList.length > 0; 

    const hasOCFilters = 
      activeFilters.ocNumbers && activeFilters.ocNumbers.length > 0;

    const hasStatusGeneralFilters = 
      activeFilters.statusGeneralIds && activeFilters.statusGeneralIds.length > 0;
    
  
  return hasDateFilters || hasSolpedFilters || hasAtcFilters || hasOtFilters || hasCenterFilters || hasOCFilters || hasStatusGeneralFilters; 
};

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '40px',
      maxHeight: '120px',
      overflow: 'auto',
      borderColor: '#D1D5DB',
      '&:hover': { borderColor: '#D1D5DB' },
      boxShadow: state.isFocused ? 'none' : base.boxShadow,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px'
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 9999,
      marginTop: '4px',
      width: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'ITC-book, sans-serif', 
      fontSize: '14px'
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px'
    }),
  input: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  singleValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  placeholder: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  option: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  };

const validateNumericInput = (inputValue, action) => {
  if (action === 'input-change') {
    return inputValue.replace(/[^0-9]/g, '');
  }
  return inputValue;
};

  const numericFilterOption = (option, rawInput) => {
    const input = rawInput.replace(/[^0-9]/g, '');
    return option.label.includes(input);
  };

const handleKeyDownNumeric = (e) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End'
  ];
  
  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
    return; 
  }
  
  if (!/^\d$/.test(e.key)) {
    e.preventDefault(); 
  }
};

const validateTextInput = (inputValue, action) => {
  if (action === 'input-change') {
    return inputValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  }
  return inputValue;
};

const textFilterOption = (option, rawInput) => {
  const input = rawInput.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  return option.label.toLowerCase().includes(input.toLowerCase());
};

const handleKeyDownText = (e) => {
  
  const allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End', ' '
  ];
  
  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
    return; 
  }
  
  if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key)) {
    e.preventDefault(); 
  }
};
  
  return (
    <div className='relative' ref={filtersRef}>
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[105px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveFilters() 
            ? 'bg-blue-light text-white' 
            : 'bg-transparent text-[#6B7280]'
        }`}
      >
        Filtrar por
      </button>
      
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12 overflow-y-auto max-h-[300px] md:max-h-[400px] rounded-lg w-[266px] sm:w-[372px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
        >
          <div className='flex flex-col gap-3'>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>

            {/* Filtro por Fecha de creación */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>
                Fecha de creación:
              </p>
              <DateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                value={selectedDateRange}
              />
            </div>

            {/* Filtro por Estado General del Servicio */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado general del servicio</p>
              <Select
                isMulti
                isLoading={loadingEstadoGeneral}
                isDisabled={loadingEstadoGeneral}
                options={estadoGeneralOptions}
                value={selectedEstadoGeneral}
                onChange={handleEstadoGeneralChange}
                placeholder="Seleccione estados"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingEstadoGeneral ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onInputChange={validateTextInput}
                filterOption={textFilterOption}
                onKeyDown={handleKeyDownText}
              />
            </div>

            {/* Filtro por Número de Solped */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número Solped</p>
              <Select
                isMulti
                isLoading={loadingSolpeds}
                isDisabled={loadingSolpeds}
                options={solpedOptions}
                value={selectedSolpeds}
                onChange={handleSolpedChange}
                placeholder="Seleccione números Solped"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingSolpeds ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Filtro por Número ATC*/}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de ATC</p>
              <Select
                isMulti
                isLoading={loadingNumberAtc}
                isDisabled={loadingNumberAtc}
                options={numberAtcOptions}
                value={selectedNumberAtc}
                onChange={handleNumberAtcChange}
                placeholder="Seleccione números de ATC"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingNumberAtc ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Número de OT */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de OT</p>
              <Select
                isMulti
                isLoading={loadingNumeroOT}
                isDisabled={loadingNumeroOT}
                options={numeroOTOptions}
                value={selectedNumeroOT}
                onChange={handleNumeroOTChange}
                placeholder="Seleccione números de OT"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingNumeroOT ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Número de OC */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de OC</p>
              <Select
                isMulti
                isLoading={loadingNumeroOC}
                isDisabled={loadingNumeroOC}
                options={numeroOCOptions}
                value={selectedNumeroOC}
                onChange={handleNumeroOCChange}
                placeholder="Seleccione números de OC"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingNumeroOC ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Embarcación */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Centro / Embarcación</p>
              <Select
                isMulti
                isLoading={loadingCenters}
                isDisabled={loadingCenters}
                options={centersOptions}
                value={selectedCenters}
                onChange={handleCentersChange}
                placeholder="Seleccione embarcaciones"
                className="text-sm font-itcbook"
                noOptionsMessage={() => loadingCenters ? "Cargando..." : "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            <div className="flex justify-center w-full">
              <button
                onClick={handleApplyFilters}
                className="underline text-blue font-itcbold"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ATCFilters;